module.exports = __webpack_public_path__ + "img/report_page_visualization.cb831176.svg";